import { collapsibleOnClickFactory, collapsibleResizeFactory } from './controllers/collapsible.controllers.js';

collapsibleOnClickFactory(document.querySelectorAll<HTMLElement>('.faq-item-collapsible summary'));
collapsibleResizeFactory(document.querySelectorAll<HTMLElement>('.faq-item-collapsible'));
